import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface OfferState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: OfferState = {
  data: [],
  isLoading: false,
  error: null,
};

const offerSlice = createSlice({
  name: 'offer',
  initialState,
  reducers: {
    setOffers: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setOfferLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setOfferError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setOffers, setOfferLoading, setOfferError } = offerSlice.actions;

export default offerSlice.reducer;
